import {
  type OptionPickerDefaultValue,
  type TileSelectorModes,
} from '@blaze-shared/elements-domain';

import { type WidthStyle } from './styles/width';

export interface CommonFormFieldProps {
  showLabel?: boolean;
  label?: string;
  iconName?: string;
  tooltip?: string;
  height?: number;
  width?: WidthStyle;
  isReadOnly?: boolean;
  /**  Ignored outside of a form's custom layout. */
  field?: string;
}

/** Linked-field display/sort configuration */
export interface LinkDisplayProperties {
  display?: string;
  sortBy?: string;
}

export type SelectionTemplate = 'Classic' | 'Chip' | 'Box';
export type DropdownDefaultValue = 'None' | 'First' | 'Last' | 'Placeholder';
export type SelectionDefaultValue = 'None' | 'First';
export type SelectionLayout = 'Row' | 'Column';

const DEFAULT_VALUE_MAP: Record<
  DropdownDefaultValue | SelectionDefaultValue,
  OptionPickerDefaultValue
> = {
  None: 'none',
  First: 'first',
  Last: 'last',
  Placeholder: 'placeholder',
};

export function toOptionPickerDefaultValue(
  value: DropdownDefaultValue | SelectionDefaultValue | undefined,
): OptionPickerDefaultValue | undefined {
  return value ? DEFAULT_VALUE_MAP[value] : undefined;
}

const TILE_SELECTOR_MODE_MAP: Record<SelectionTemplate, TileSelectorModes> = {
  Classic: 'text',
  Chip: 'chip',
  Box: 'box',
};

export function toTileSelectorMode(
  template: SelectionTemplate | undefined,
): TileSelectorModes | undefined {
  return template ? TILE_SELECTOR_MODE_MAP[template] : undefined;
}

export function toSelectionLayout(
  layout: SelectionLayout | undefined,
): 'row' | 'column' | undefined {
  if (!layout) {
    return undefined;
  }

  return layout === 'Row' ? 'row' : 'column';
}
